<template>
<div  class="docHolder">
  <div v-if="false" style="width:1000px;position:absolute;left:0px;height:200px;background-color:#00ff00;">STUFF

     <div  style="top:40px;right: 10px;" class="helpIcon" @click="showHelp"></div>
  </div>
  <div  ref="dragZoom" class=scanHolder :style="holderStyle">
  <div   class="scanImage" :style="style"></div>
  </div>
  
   <div v-if="scanning" class="scanOverlay" :style="styleScan"></div>
   <div v-if="scanning" class="scanOverlay" :style="styleScanV"></div>

   <div v-if="!scanning && active && allowScan && !scanned"  :state="true" class="scanBtn doScan" @click="scanDoc">SCAN DOCUMENT</div>
   <div v-if="!scanning && !docAction && scanned && active" :state="true" class="scanBtn doScan" @click="finishScan">SHOW SCAN RESULTS</div>
   <div v-if="height>300">
   <div v-if="zoom==1" class="zoomBtn" @click="doZoom"> + </div>
   <div v-else class="zoomBtn" @click="doZoomOut"> - </div>
   </div>

 </div>
</template>

<script>
//import Help from '@/mixins/help'
import glowBtn from "@/components/glowBtn.vue";
import notify from 'devextreme/ui/notify';
import gsap from "gsap";
import Nodes from '@/mixins/nodes'

export default {
  mixins:[Nodes],
  components: {
    glowBtn
  },
  props: {
    mapVis:{
      default:false
    },
    allowScan:{
      default:true
    },
    document:null,
    active:false,
    label:null,
    width: {
      default: 180
    },
   height: {
      default: 180
    },
    colour: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      zoom:1,
      scanX:0,
      scanY:0,
      dragPos: { top: 0, left: 0, x: 0, y: 0 },
      scanning:false,
      scanned:false,
      showResults:false,
      aniframe:null,
      animation: {
        hide:{ type: 'slide', duration: 1000, to:{ position: {  
              my: 'top left',  
              at: 'top right',  
              of: window,  
              offset: '0 0'  
          }}},
        show:{ type: 'slide', duration: 1000, from:{ position: {  
              my: 'top left',  
              at: 'top right',  
              of: window,  
              offset: '0 0'  
          }} }
        },
       /* helps:[	
        {id:"H901_haveFound",showOnce:false,shown:false,help:{}},
				{id:"H006_planningmap",showOnce:true,shown:false,help:{}},
				{id:"H007_readyToDive",showOnce:false,shown:false,help:{}}
			]
      */
      
    };
  },
  mounted(){
    console.log("DOCUMENT",this.document)
  },
  computed: {
    fireBaseLoc(){
					return this.$store.getters.getFireBaseLoc					
			},
    modWidth(){
      return this.width*this.zoom
    },
    modHeight(){
      return this.height*this.zoom
    },
   docAction(){
      return this.$store.getters.getDocAction
    },
    mapZones(){
      if(this.document && this.document.maps){
        return this.$store.getters.getMapZones(this.document.maps)
      }
    },
    mapList(){
      if(this.document){
        return this.getMaps(this.document.maps)
      }
    },
    infoList(){
      if(this.document && this.document.info){
        return this.getInfo(this.document.info)
      }
    },
    evidenceList(){
      if(this.document){
        return this.getEvidence(this.document.evidence)
      }
    },
    actionList(){
      if(this.document){
        return this.getActions(this.document.actions)
      }
    },
      
    imagePath(){
      if(this.document.image){
       
        let imageInfo=this.document.image.split("|")
        if(imageInfo.length>0){
           return this.fireBaseLoc+"images/"+imageInfo[1].split('images%2F')[1].split('?')[0]
        }
        return require('../assets/images/docs/'+this.document.image)
      }else if(this.document.image){
        return require('../assets/images/thumbnails/'+this.document.thumbnail)
      }else{
        return null
        return 'experts/'+this.document.name+'.png'
      }
    },
    holderStyle(){
       let style=""
       if(this.height>300){
         style+="top:100px;"
       }
      return style+"width:" + this.width + "px; height:"+this.height+"px; ";
    },
    style() {
      let style=""
      if(this.imagePath){
        var url=this.imagePath
        style+="background-image:url('"+url+"');background-size:contain;background-position: center;"
      }
     
      return style+"width:" + this.modWidth + "px; height:"+this.modHeight+"px; ";
    },
    styleScan() {
      var style=""
      if(this.document.name){
        var url=this.imagePath
        //style+="background-color:#ff000099;"
        
        style+="background-image:url('"+url+"');"
      }
       style+="left:"+this.scanX+"px;"
       style+="background-position:"+(-this.scanX)+"px 0px;"
       return style+"width:" + (5) + "px; height:"+(this.height+72)+"px;top:-10px;";
      //return style+"width:" + (this.width*.01) + "px; height:"+this.height+"px;margin-bottom:20px;";
    },
    styleScanV() {
      var style=""
      if(this.document.name){
        var url=this.imagePath
        //style+="background-color:#ff000099;"
        
        style+="background-image:url('"+url+"');"
      }
       style+="top:"+this.scanY+"px;"
       style+="background-position: 0px "+(-this.scanY)+"px;"
       return style+"width:" + (this.width+10) + "px; height:"+(5)+"px;margin-bottom:0px;";
      //return style+"width:" + (this.width) + "px; height:"+(this.width*.01)+"px;margin-bottom:20px;";
    },
    state() {
      if (this.document) {
        return this.document.state;
      }
      return "";
    }
  },



  
  methods: {
    mouseDownHandler(e) {
      this.$refs.dragZoom.style.cursor = 'grabbing';
      this.dragPos = {
        // The current scroll 
        left: this.$refs.dragZoom.scrollLeft,
        top: this.$refs.dragZoom.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      }
      document.addEventListener('mousemove', this.mouseMoveHandler);
      document.addEventListener('mouseup', this.mouseUpHandler);
    },
    mouseUpHandler() {
        this.$refs.dragZoom.style.cursor = 'grab';
       this.$refs.dragZoom.style.removeProperty('user-select');

        document.removeEventListener('mousemove', this.mouseMoveHandler);
        document.removeEventListener('mouseup', this.mouseUpHandler);
    },
    
    mouseMoveHandler(e) {
    // How far the mouse has been moved
    const dx = e.clientX - this.dragPos.x;
    const dy = e.clientY - this.dragPos.y;

    // Scroll the element
    this.$refs.dragZoom.scrollTop = this.dragPos.top - dy;
    this.$refs.dragZoom.scrollLeft = this.dragPos.left - dx;
    },
    enableZoomDrag(){
      
      
      this.$refs.dragZoom.style.cursor = 'grab';
     

    
    this.$refs.dragZoom.addEventListener('mousedown', this.mouseDownHandler);
    },
    doZoom(){
      console.log("ZOOM",this.zoom,this.modWidth)
      this.zoom=1.5
      this.enableZoomDrag()
    },
    doZoomOut(){
      this.zoom=1
       
       this.$refs.dragZoom.removeEventListener('mousedown', this.mouseDownHandler);
       this.$refs.dragZoom.style.cursor = 'default';
    },
    showScene(scene){
      this.$store.commit("setCutScene",scene)
    },
    changeLoc(loc,l){
      //loc.selected=this.check[l]
    },
    changeEvi(evi,e){
      //evi.selected=this.eviCheck[e]
    },
    changeAct(act,a){
      //act.selected=this.actCheck[a]
    },
    showMap(){
      this.$emit("showMap")
    },
    
    
    finishScan(){
      
       cancelAnimationFrame(this.animFrame)
       this.scanX=0
       this.scanY=0
        this.scanning=false
       this.scanned=true
       //this.showResults=true
       //this.showHelp()
       this.$store.commit("setDocAction",this.document)
       
    },
    scanDoc(){
      if(this.scanning){
        cancelAnimationFrame(this.animFrame)
        this.scanning=false
      }else{
        this.scanning=true
        this.step()
      }
    },
    step(){
      if(this.scanX<this.width-20){
        this.scanX=this.scanX+this.width/100
        this.scanY=this.scanY+this.height/100
        this.animFrame=requestAnimationFrame( this.step );
      }else{
        this.finishScan()
      }
      
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/sass/variables.scss";
.docHolder{
  max-height:60%;
  display:flex;
  position:relative;
  padding:0px 0px;
  width:100%;
  align-items: center;
  justify-content: center;
 .scanBtn{
   width:90%;
   margin:auto;
   text-align: center;
   position:absolute;
   top:0px;
   cursor:pointer;
 }
 .doScanOld{
   font-weight: 800;
    font-size: 16px;
    padding: 0px 10px;
    color: #ff8f00;
    border: #ffae00 solid;
    border-radius: 5px;
    border-top: none;
    border-bottom: none;
    background-color: #fffffff0;
    box-shadow: #b5590b 0px 0px 20px 5px;
 }
 .doScan:hover{
   background-color: #f9d194;
 }
 
 .doScan{
   font-weight: 800;
    font-size: 16px;
    padding: 0px 10px;
    color: #08ea08;
    border: #08ea08 solid 2px;
    border-radius: 5px;
    /* border-top: none; */
    /* border-bottom: none; */
    /* background-color: #fffffff0; */
     -webkit-box-shadow: #08ea08 0px 0px 20px 5px; 
    box-shadow: inset #08ea08 0px 0px 20px 0px;
    background-color:#000c;
    cursor: pointer;
 }
 .doScan:hover{
   color: #00ff00;
   background-color:#000c;
   box-shadow:  #08ea08 0px 0px 20px 5px;
   box-shadow: inset #08ea08 0px 0px 20px 0px, #08ea08 0px 0px 20px 1px ;
   
 }
}
.scanHolder{
  position: relative;
  overflow:auto;
  padding-top: 15px;
}
.scanImage {
  width:190px;
  height:140px;
  position: absolute;
  margin:auto;
  background-size: 100% auto;
  background-repeat: no-repeat;
  opacity: .8;
}
.scanOverlay {
  filter: brightness(1)  drop-shadow(0px 0px 10px red) invert(1);
  height:140px;
  position: absolute;
  top:0px;
  left:0px;
  cursor: pointer;
  background-size: cover;
  border:#330000 solid 2px;
  border-top:none;
  border-bottom:none;
  
}
.scanResults{
  text-transform: capitalize;
    width: calc(100% - 80px);
    max-height: calc(100% - 200px);
    padding: 10px;
    /* margin: 10px; */
    text-align: left;
    position: absolute;
    top: -5px;
    left: 0px;
    text-align: left;
    position: absolute;
    height: calc(100% -100px);
    min-height: 200px;
    left: 0px;
    top: 0px;
    bottom: 0px;
    margin: auto;
    left: 0px;
    right: 0px;
    background-color: #000d;
    /* background: linear-gradient(#006677ed 1px, #02142fbb 1px); */
    background-size: 100% 5px;
    color: #3df;
}
.zoomBtnOld{
  border-radius:3px;
  background-color: #ffffff;
    color: #ff9900;
    position: absolute;
    top: -4px;
    left: 9px;
    font-size: 30px;
    font-weight: bold;
    padding: 0px 1px;
    cursor: pointer;
}
.zoomBtn{
    color: #ff9900;
    border: #ff9900 solid 2px;
    border-radius: 5px;
    position: absolute;
   top: 36px;
    left: 3px;
     -webkit-box-shadow: #ff9900 0px 0px 20px 5px; 
    box-shadow: inset #ff9900 0px 0px 20px 0px;
    font-size: 30px;
    font-weight: bold;
    padding: 0px 9px;
    cursor: pointer;
    background-color:#000c;
 }
 .zoomBtn:hover{
   color: #ff9900;
   background-color:#000c;
   box-shadow:  #ff9900 0px 0px 20px 5px;
   box-shadow: inset #ff9900 0px 0px 20px 0px, #ff9900 0px 0px 20px 1px ;
   
 }
.scanResultsX{
  text-transform:capitalize;
  width:calc(100% - 20px);
    height: calc(100% + 10px);
    padding: 10px;
    /* margin: 10px; */
    text-align: left;
    position: absolute;
    top: -5px;
    left: 0px;
  text-align:left;
   position: absolute;
  top:-5px;
  left:0px;
 

 /*background: $panel3-bg;*/
 background: linear-gradient(#006677ed 1px, #02142fbb 1px);
 background-size: 100% 5px;
   color:#3df;
   .padTop{
      padding-top:10px;
    }
}

.inlineBtn{
  display:inline-block;
  color:#ff9900;
  height:20px;
   cursor:pointer;
}
.checkBox{
  display:inline-block;
  color:#a9ff00;
  height:20px;
  cursor:pointer;
}
.baseButton{
  width: 100%;
    text-align: center;
    bottom: 20px;
}
</style>